import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefplan-kopieren';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefplanKopierenEffects {

    PruefplanKopieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFPLAN_KOPIEREN),
        mergeMap((x: ac.PostPruefplanKopierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefplanKopieren(x.pruefplanRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefplanKopierenErfolgreichAction(result, x.pruefplanRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefplanKopierenFehlerAction(error, x.pruefplanRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
